/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Analyze_Allocations_TitleInputs */

const en_admin_analyze_allocations_title = /** @type {(inputs: Admin_Analyze_Allocations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocations`)
};

const de_admin_analyze_allocations_title = /** @type {(inputs: Admin_Analyze_Allocations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuweisungen`)
};

const es_admin_analyze_allocations_title = /** @type {(inputs: Admin_Analyze_Allocations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignaciones`)
};

const fr_admin_analyze_allocations_title = /** @type {(inputs: Admin_Analyze_Allocations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributions`)
};

/** @type {(inputs: Admin_Analyze_Allocations_TitleInputs) => LocalizedString} */
const it_admin_analyze_allocations_title = en_admin_analyze_allocations_title;

/** @type {(inputs: Admin_Analyze_Allocations_TitleInputs) => LocalizedString} */
const pt_br2_admin_analyze_allocations_title = en_admin_analyze_allocations_title;

/** @type {(inputs: Admin_Analyze_Allocations_TitleInputs) => LocalizedString} */
const pl_admin_analyze_allocations_title = en_admin_analyze_allocations_title;

/** @type {(inputs: Admin_Analyze_Allocations_TitleInputs) => LocalizedString} */
const hu_admin_analyze_allocations_title = en_admin_analyze_allocations_title;

/** @type {(inputs: Admin_Analyze_Allocations_TitleInputs) => LocalizedString} */
const ro_admin_analyze_allocations_title = en_admin_analyze_allocations_title;

/**
* | output |
* | --- |
* | "Allocations" |
*
* @param {Admin_Analyze_Allocations_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_analyze_allocations_title = /** @type {((inputs?: Admin_Analyze_Allocations_TitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Analyze_Allocations_TitleInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_analyze_allocations_title(inputs)
	if (locale === "de") return de_admin_analyze_allocations_title(inputs)
	if (locale === "es") return es_admin_analyze_allocations_title(inputs)
	if (locale === "fr") return fr_admin_analyze_allocations_title(inputs)
	if (locale === "it") return it_admin_analyze_allocations_title(inputs)
	if (locale === "pt-BR") return pt_br2_admin_analyze_allocations_title(inputs)
	if (locale === "pl") return pl_admin_analyze_allocations_title(inputs)
	if (locale === "hu") return hu_admin_analyze_allocations_title(inputs)
	return ro_admin_analyze_allocations_title(inputs)
});
export { admin_analyze_allocations_title as "admin.analyze.allocations.title" }